import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

export default function FullImageModal({ isOpen, onClose, images, initialIndex = 0, title }) {
  const [index, setIndex] = useState(initialIndex);
  useEffect(() => { setIndex(initialIndex); }, [initialIndex, isOpen]);
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowRight") setIndex((prev) => (images && prev < images.length - 1 ? prev + 1 : 0));
      else if (e.key === "ArrowLeft") setIndex((prev) => (images && prev > 0 ? prev - 1 : (images ? images.length - 1 : 0)));
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, images, onClose]);

  if (!isOpen || !images || images.length === 0) return null;
  const currentImg = images[index] || images[0];

  return (
    <Box onClick={onClose} style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.93)", zIndex: 100000, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", backdropFilter: "blur(8px)", padding: "16px", boxSizing: "border-box", cursor: "zoom-out" }}>
      <Box onClick={(e) => e.stopPropagation()} style={{ position: "absolute", top: "16px", left: "24px", right: "24px", display: "flex", justifyContent: "space-between", alignItems: "center", zIndex: 100002, color: "#ffffff", cursor: "default" }}>
        <Typography variant="subtitle1" style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, color: "#ffffff", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "75%" }}>
          {title || "Full Image"}
        </Typography>
        <Box display="flex" alignItems="center" gap={2}>
          {images.length > 1 && <Box style={{ backgroundColor: "rgba(255,255,255,0.18)", color: "#fff", padding: "3px 12px", borderRadius: "14px", fontSize: "0.82rem", fontWeight: 600 }}>{index + 1} / {images.length}</Box>}
          <IconButton onClick={onClose} size="small" style={{ color: "#ffffff", backgroundColor: "rgba(255,255,255,0.18)" }}><CloseIcon /></IconButton>
        </Box>
      </Box>
      <Box onClick={(e) => e.stopPropagation()} style={{ maxWidth: "92vw", maxHeight: "84vh", display: "flex", justifyContent: "center", alignItems: "center", cursor: "default" }}>
        <img src={currentImg} alt={title || "Full View"} style={{ maxWidth: "100%", maxHeight: "84vh", objectFit: "contain", borderRadius: "6px", boxShadow: "0 8px 32px rgba(0,0,0,0.5)" }} />
      </Box>
    </Box>
  );
}
